import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import styles from './styles.scss';

export function GoBack(props) {
    return (
        <Link
            {...props}
            className={classnames(styles.backArea, props.className)}
            data-cy="GoBack-Link"
        >
            <span className={styles.materialIcons}>arrow_back</span>
            <span className={styles.backLabel}>{props.children}</span>
        </Link>
    );
}
